<template>
  <div id="app" class="loader-section">
    <atom-spinner :animation-duration="1000" :size="60" :color="'#ff1d5e'" />
    <h3 class="mt-3">Processing Data...</h3>
  </div>
</template>
<style>
.loader-section {
  flex-direction: column;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<script>
import { AtomSpinner } from "epic-spinners";
export default {
  components: {
    AtomSpinner,
  },
};
</script>
